<template lang="html">
<div class="selected-station">
    <div v-if="station">
        <streamflow-station v-if="routeName === 'streamflow'" />
        <surface-quality-station v-if="routeName === 'surfacewaterquality'" />
        <ground-quality-station v-if="routeName === 'groundwaterquality'" />
        <ground-level-station v-if="routeName === 'groundwaterlevel'" />
        <climate-station v-if="routeName === 'climate'" />
    </div>
</div>
</template>

<script>
// components
import StreamflowStation from '@/components/SidebarStationStreamflow';
import SurfaceQualityStation from '@/components/SidebarStationSurfaceQuality';
import GroundQualityStation from '@/components/SidebarStationGroundQuality';
import GroundLevelStation from '@/components/SidebarStationGroundLevel';
import ClimateStation from '@/components/SidebarStationClimate';

export default {
    name: 'selected-station',
    components: {
        StreamflowStation,
        SurfaceQualityStation,
        GroundQualityStation,
        GroundLevelStation,
        ClimateStation,
    },
    data() {
        return {

        };
    },
    computed: {
        station() {
            return this.$store.state.map.selectedStation;
        },
        routeName() {
            return this.$route.name.toLowerCase();
        },
    },
};
</script>

<style lang="scss">
.selected-station {
    h3.station-name {
        clear: both;
    }

    .loading {
        height: 40vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/SidebarStation.vue